/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Flower24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Flower 24">
      <path
        fill="#5E1FF0"
        d="M11.058.664a1 1 0 0 1 1.884 0v.002l.002.004.004.012.015.044.054.16a30.229 30.229 0 0 1 .752 2.71c.405 1.737.818 4.097.835 6.57v.156a26.54 26.54 0 0 1-.19 2.93c.4-.497.833-.994 1.299-1.47l.045-.046.002-.002.002-.001.043-.044c1.5-1.49 3.186-2.65 4.488-3.434a26.99 26.99 0 0 1 2.114-1.149l.132-.062.037-.017.01-.004.004-.002h.002a1 1 0 0 1 1.323 1.316l-.002.004-.005.01-.016.038-.062.133a27.327 27.327 0 0 1-1.138 2.13c-.778 1.313-1.927 3.013-3.405 4.525l-.043.043-.001.002-.003.003-.002.001-.043.043c-.497.494-1.014.952-1.532 1.371 1.492.024 2.898.323 3.929.612a17.837 17.837 0 0 1 1.66.555l.102.041.028.012.009.004.003.001.002.001a1 1 0 0 1 0 1.837l-.003.001-.009.004-.028.012-.102.042a17.96 17.96 0 0 1-1.662.561c-.894.253-2.07.515-3.34.599a11.41 11.41 0 0 1 .937 1.158l.046.068.014.02.004.006.003.004a1 1 0 0 1-.891 1.543h-.012l-.024-.002a8.47 8.47 0 0 1-.364-.034 11.245 11.245 0 0 1-.956-.152c-.76-.155-1.78-.443-2.735-.982l-.023-.013-.001-.001-.004-.002-.002-.001-.02-.012c-.94-.553-1.701-1.288-2.224-1.877-.523.589-1.284 1.325-2.223 1.877l-.021.012h-.002l-.001.002-.004.002h-.002l-.02.013c-.956.54-1.976.827-2.736.982a11.254 11.254 0 0 1-1.238.18 4.698 4.698 0 0 1-.082.006l-.024.002h-.013a1 1 0 0 1-.889-1.544l.002-.003.005-.006.013-.02a6.125 6.125 0 0 1 .211-.299 11.158 11.158 0 0 1 .772-.927 16.411 16.411 0 0 1-3.34-.6 17.96 17.96 0 0 1-1.662-.56 7.232 7.232 0 0 1-.102-.042l-.028-.012-.009-.004-.003-.001H.602a1 1 0 0 1 .003-1.837h.001l.003-.002.009-.004.029-.012.1-.04a17.856 17.856 0 0 1 1.66-.555c1.032-.29 2.438-.589 3.93-.613a20.487 20.487 0 0 1-1.532-1.37l-.045-.046-.003-.002-.001-.001-.043-.044c-1.478-1.512-2.627-3.212-3.405-4.525A27.314 27.314 0 0 1 .17 8.522a12.03 12.03 0 0 1-.062-.133l-.016-.037-.005-.011-.002-.003v-.002A1 1 0 0 1 1.409 7.02h.001l.004.002.01.004.037.017.132.062a26.977 26.977 0 0 1 2.114 1.148C5.01 9.04 6.696 10.2 8.195 11.69l.046.046.002.002.001.001.043.044c.466.477.9.973 1.3 1.47a26.535 26.535 0 0 1-.191-2.93v-.156c.017-2.473.43-4.833.834-6.57.206-.88.41-1.607.565-2.116a24.429 24.429 0 0 1 .242-.754l.015-.044.004-.012.001-.004.001-.002Z"
        className="Fill-Main"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Flower24,
  md: Flower24,
  lg: Flower24,
  xl: Flower24,
  xxl: Flower24,
  xxxl: Flower24,
};

export const FlowerIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'flower-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
